import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { DoctorAccountControlRequest } from '@jema-manager/shared';
import { useAuthStore } from './auth-store';

export const DOCTOR_CONTROL_STORE_KEY = 'jema_doctor_control_mode_v1';

type DoctorControlStoreState = {
  activeRequest: DoctorAccountControlRequest | null;
  setActiveRequest: (request: DoctorAccountControlRequest | null) => void;
  clearControl: () => void;
};

export const useDoctorControlStore = create<DoctorControlStoreState>()(
  persist(
    set => ({
      activeRequest: null,
      setActiveRequest: request => set({ activeRequest: request }),
      clearControl: () => set({ activeRequest: null }),
    }),
    {
      name: DOCTOR_CONTROL_STORE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({
        activeRequest: state.activeRequest,
      }),
    }
  )
);

export const getDoctorControlRequestIdFromStorage = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(DOCTOR_CONTROL_STORE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as {
      state?: { activeRequest?: { id?: string | null } | null };
    };

    return parsed?.state?.activeRequest?.id ?? null;
  } catch {
    return null;
  }
};

export const clearDoctorControlStorage = () => {
  try {
    localStorage.removeItem(DOCTOR_CONTROL_STORE_KEY);
  } catch {
    // no-op
  }

  useDoctorControlStore.getState().clearControl();
  useAuthStore.getState().exitDoctorControlMode();
};
